/** Customer-facing copy for in-page Example previews (never “dummy” / eng jargon). */
export const EXAMPLE_PREVIEW_COPY = {
  yourDataTitle: 'Your data',
  yourDataThin:
    'You’ve only been testing for a short while. A full workday will give you a more useful view.',
  yourDataOwnDay:
    'This is your own workday — this is what you’ll see for each employee.',
  exampleLabel: 'Example workday · Not your company data',
  exampleLeadHours:
    'What this page looks like with a complete workday — not your company data.',
  exampleLeadApps:
    'What Apps & Websites looks like with a complete workday — not your company data.',
  tryOneEmployee: 'Try it with one employee',
  tryOneEmployeeSupport: 'Ready when you are — we’ll help you introduce it fairly, including what to say.',
  controlTitle: 'You control these',
  controlSupport:
    'You can change these in Settings anytime. During this install, leave capture settings alone so your own results stay clean.',
  controlItems: [
    {
      title: 'Screenshot frequency',
      detail:
        'Set the interval in minutes, or turn periodic capture off. Webcam stays off unless you explicitly add it.',
    },
    {
      title: 'How it runs per employee',
      detail:
        'Visible (they pause), Visible (admin start/stop), or Hidden — chosen when you add each employee.',
    },
    {
      title: 'Work window',
      detail: 'Define shifts so tracking only counts work hours.',
    },
    {
      title: 'Daily Insights',
      detail: 'Choose who receives the email summary.',
    },
    {
      title: 'Your data',
      detail: 'Delete or export screenshots and logs any time from Data Management.',
    },
  ] as const,
} as const;
